import { render, staticRenderFns } from "./available-burs-list.vue?vue&type=template&id=745970c2&"
import script from "./available-burs-list.vue?vue&type=script&lang=js&"
export * from "./available-burs-list.vue?vue&type=script&lang=js&"
import style0 from "./available-burs-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports